module.exports = __webpack_public_path__ + "img/World map Icon - charcoal.9ebb637c.svg";